// extracted by mini-css-extract-plugin
module.exports = {"list":"Breadcrumbs_list__P8rHi","link":"Breadcrumbs_link__roIar","link--as-link-style":"Breadcrumbs_link--as-link-style__yeheT","link-wrapper":"Breadcrumbs_link-wrapper__fRvHt"};